import config from "@/constants/config";
import { clearStorage, StorageKey } from "@/constants/storage";

const OIDC_STORAGE_PREFIX = "oidc.";

const AUTH_CALLBACK_QUERY_PARAMS = [
  "code",
  "state",
  "session_state",
  "iss",
  "scope",
];

export const isLoginEnabled = (): boolean => {
  return config.featureFlags.isLoginEnabled;
};

export const clearPersistedAuthState = (): void => {
  clearStorage(StorageKey.USER);

  const storage = globalThis.localStorage;
  const keysToRemove: string[] = [];

  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index);

    if (key?.startsWith(OIDC_STORAGE_PREFIX)) {
      keysToRemove.push(key);
    }
  }

  for (const key of keysToRemove) {
    storage.removeItem(key);
  }
};

export const clearAuthCallbackParams = (): void => {
  const url = new URL(globalThis.location.href);
  let hasAuthParams = false;
  const hashSearchParams = new URLSearchParams(url.hash.replace(/^#/, ""));

  for (const param of AUTH_CALLBACK_QUERY_PARAMS) {
    if (url.searchParams.has(param)) {
      hasAuthParams = true;
      url.searchParams.delete(param);
    }

    if (hashSearchParams.has(param)) {
      hasAuthParams = true;
      hashSearchParams.delete(param);
    }
  }

  const nextHash = hashSearchParams.toString();

  if (url.hash && !nextHash) {
    url.hash = "";
  } else if (nextHash) {
    url.hash = `#${nextHash}`;
  }

  if (hasAuthParams) {
    globalThis.history.replaceState({}, "", url.toString());
  }
};

export const enforceDisabledAuthStartupState = (): void => {
  if (isLoginEnabled()) {
    return;
  }

  clearPersistedAuthState();
  clearAuthCallbackParams();
};
